export const NAV_SITES = [
    {
        name: '时间戳工具',
        type: 'tool',
        toolId: 'timestamp',
        // 紫5352ED
        containerClass: 'bg-[#2ed573] text-white rounded-xl border-none transition-transform duration-200 hover:scale-[1.02] active:scale-95'
    },
    { 
        name: 'JSON 格式', 
        type: 'tool',
        toolId: 'json-format',
        // 蓝
        containerClass: 'bg-[#1E90FF] text-white rounded-xl border-none transition-transform duration-200 hover:scale-[1.02] active:scale-95' 
    },
    { 
        name: '随机生成器', 
        type: 'tool',
        toolId: 'random-gen',
        // 扁平化深蓝色方案
        containerClass: 'bg-[#08d9d6] text-white rounded-xl border-none transition-transform duration-200 hover:scale-[1.02] active:scale-95 shadow-lg shadow-indigo-100' 
    },
    { 
        name: '哈希与加密', 
        type: 'tool',
        toolId: 'crypto-tool',
        containerClass: 'bg-[#FF4757] text-white rounded-xl border-none transition-transform duration-200 hover:scale-[1.02] active:scale-95 shadow-lg shadow-red-100' 
    },
    { 
        name: '文本工具', 
        type: 'tool',
        toolId: 'rich-editor',
        containerClass: 'bg-[#9f93fb] text-white rounded-xl border-none transition-transform duration-200 hover:scale-[1.02] active:scale-95 shadow-lg shadow-red-100' 
    },
    {
        name: 'CCTV 直播',
        type: 'link',
        url: 'https://tv.cctv.com/live/index.shtml',
        // 橙红
        containerClass: 'bg-[#fff] text-[#222] rounded-xl border-none transition-transform duration-200 hover:scale-[1.02] active:scale-95' 
    }
];